export enum ApplicationTabs {
  Roles = 0,
  Profiles = 1,
}
